import { capitalize } from 'lodash';
import { ReactNode } from 'react';
import { RolePermissionFormField } from '../../api/graphql/generated';
import { i18nKeyType } from '../../i18n';
import { getLocalizedText } from '../../i18n/i18n.utils';
import { NumericInputWidget } from '../../scratchpad/application/shared/component/widget/numeric-input';
import { PickerInput } from '../../scratchpad/application/shared/component/widget/picker-input';
import { SwitchInput } from '../../scratchpad/application/shared/component/widget/switch-input';
import {
  RolePermissionInputType,
  RolePermissionSelectMetadata,
} from './role.types';

interface RolePermissionFieldValueInputProps {
  field: RolePermissionFormField;
  type: RolePermissionInputType;
}

/**
 * This component is used to render the input field for the value of a role
 * permission.
 */
const RolePermissionFieldValueInput = (
  props: RolePermissionFieldValueInputProps
): ReactNode => {
  const { field, type } = props;

  if (
    type === RolePermissionInputType.NUMBER ||
    type === RolePermissionInputType.PERCENTAGE
  ) {
    return (
      <NumericInputWidget
        label={getLocalizedText('common:amount')}
        name={`${field.template.policy}.rolePermissionInputValue`}
        ionItemProps={{
          color: 'light',
        }}
      />
    );
  } else if (type === RolePermissionInputType.SELECT) {
    const selectMetadata: RolePermissionSelectMetadata =
      field.template.metadata;
    const options = selectMetadata.options.map((option) => {
      return {
        label:
          getLocalizedText(option.label as i18nKeyType) ??
          capitalize(option.label),
        value: option.value as string,
      };
    });

    if (selectMetadata.multiple) {
      const optionToggles = options.map((option) => {
        return (
          <SwitchInput
            key={option.value}
            name={`${field.template.policy}.rolePermissionInputValue.${option.value}`}
            label={option.label}
            ionItemProps={{ color: 'light', lines: 'none' }}
          />
        );
      });
      return <>{optionToggles}</>;
    } else {
      return (
        <PickerInput
          name={`${field.template.policy}.rolePermissionInputValue`}
          options={options}
          label={getLocalizedText('common:value')}
          ionItemProps={{ color: 'light' }}
        />
      );
    }
  }

  return null;
};

export { RolePermissionFieldValueInput };
